import { getConfig } from '@olxeu-a2b/delivery-utils/src/extras';
import PostCodeInput from './post-code-input';
import validation from './input-validation';
import { FormField } from '../order-store/order-store';
import { FIELD_NAMES } from '../../constants';

const { phonePrefix } = getConfig('country');

export const userDataFields: FormField[] = [
  {
    name: FIELD_NAMES.firstName,
    label: 'dlv_user_firstname',
    required: true,
    extraValidations: [validation.inputLength(30)],
  },
  {
    name: FIELD_NAMES.lastName,
    label: 'dlv_user_lastname',
    required: true,
    extraValidations: [validation.inputLength(30)],
  },
  {
    name: FIELD_NAMES.email,
    label: 'dlv_user_email',
    required: true,
    type: 'email',
    extraValidations: [validation.validateEmail, validation.inputLength(60)],
  },
  {
    name: FIELD_NAMES.phoneNumber,
    label: 'dlv_user_phonenumber',
    required: true,
    prefixLabel: phonePrefix,
    extraValidations: [validation.validatePhoneAreaCode, validation.validatePhone],
  },
];

export const addressDetailsFields: (FormField | FormField[])[] = [
  {
    name: FIELD_NAMES.streetName,
    label: 'dlv_user_streetname',
    required: true,
    extraValidations: [validation.inputLength(30)],
  },
  [
    {
      name: FIELD_NAMES.streetNumber,
      label: 'dlv_user_streetnumber',
      required: true,
      extraValidations: [validation.inputLength(10)],
    },
    {
      name: FIELD_NAMES.apartmentNumber,
      label: 'dlv_user_apartmentnumber',
      required: false,
      extraValidations: [validation.inputLength(10)],
    },
  ],
  new PostCodeInput(),
  {
    name: FIELD_NAMES.city,
    label: 'dlv_user_city',
    required: true,
    extraValidations: [validation.inputLength(30)],
  },
];

export default [
  {
    name: FIELD_NAMES.firstName,
    label: 'dlv_user_firstname',
    required: true,
    extraValidations: [validation.inputLength(30)],
  },
  {
    name: FIELD_NAMES.lastName,
    label: 'dlv_user_lastname',
    required: true,
    extraValidations: [validation.inputLength(30)],
  },
  {
    name: FIELD_NAMES.streetName,
    label: 'dlv_user_streetname',
    required: true,
    extraValidations: [validation.inputLength(30)],
  },
  {
    name: FIELD_NAMES.streetNumber,
    label: 'dlv_user_streetnumber',
    required: true,
    extraValidations: [validation.inputLength(10)],
  },
  {
    name: FIELD_NAMES.apartmentNumber,
    label: 'dlv_user_apartmentnumber',
    required: false,
    extraValidations: [validation.inputLength(10)],
  },
  {
    name: FIELD_NAMES.city,
    label: 'dlv_user_city',
    required: true,
    extraValidations: [validation.inputLength(30)],
  },
  new PostCodeInput(),
  {
    name: FIELD_NAMES.email,
    label: 'dlv_user_email',
    required: true,
    type: 'email',
    readOnly: true,
    extraValidations: [validation.validateEmail, validation.inputLength(60)],
  },
  {
    name: FIELD_NAMES.phoneNumber,
    label: 'dlv_user_phonenumber',
    required: true,
    prefixLabel: phonePrefix,
    extraValidations: [validation.validatePhoneAreaCode, validation.validatePhone],
  },
];
